import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState,
    fetchActivities,
    fetchActivitiesSuccess,
    fetchActivitiesFail
} from './users.action';
import { Activity, User } from './users.model';

export interface UserRecordsState {
    listData: any[];
    singleData: User;
    loading: boolean;
    error: any;

    activities: Activity[];
    activity_loading: boolean;
    activity_error: any;
    total: number;
    totalActivity: number;

}

export const initialState: UserRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    
    activities: [],
    activity_loading: false,
    activity_error: null,
    total: 0,
    totalActivity: 0

};


export const userRecordReducer = createReducer(
    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),


    on(fetchActivities, (state) => {
        return { ...state, activity_loading: true, activity_error: null };
    }),
    on(fetchActivitiesSuccess, (state, { activities, totalActivity }) => {
        return { ...state, activities: activities, totalActivity, activity_loading: false };
    }),
    on(fetchActivitiesFail, (state, { activity_error }) => {
        return { ...state, activity_error, activity_loading: false };
    }),

    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null };
    }),

    on(resetState, () => initialState)  // Reset action handler
);